import React from 'react'
import { SlideApropos } from '../../components/apropos/slideApropos'
import Nosclients from '../../components/apropos/nosCLients'
import ServicesSection from '../../components/apropos/servicesSection'
import WorkProcess from '../../components/apropos/workProcess'
import CallToAction from '../../components/apropos/callToAction'
import TimelineSection from '../../components/apropos/timelineSection'

export const AproposPage = () => {
  return (
    <div><SlideApropos />
    {/* <Nosclients/> */}
    <ServicesSection />
    <WorkProcess />
    <TimelineSection />
    <CallToAction /></div>
  )
}
